import { useContext } from 'react';
import { Header, HeaderContext } from '@gv/triage-components';

import { HeaderWrapProps } from './types';

export const HeaderWrap = ({
  onMenu,
  ...props
}: HeaderWrapProps): JSX.Element => {
  const { pageState } = useContext(HeaderContext);

  return (
    <Header
      {...pageState}
      {...props}
      handleBurger={onMenu}
      version={process.env.REACT_APP_CODEBUILD_BUILD_NUMBER}
    />
  );
};
